import React, { useState, useEffect } from "react";
import { Typography, Grid } from "@mui/material";
import Card from "../../components/JobCard";
import JobDetailComp from "../../components/JobDetailComp";
import Button from "../../components/Button";
import { useNavigate } from "react-router-dom";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useUpdateJobStatusMutation } from "../../reducer/viewJobReducer";
import { useSendRevisedQuoteDetailsMutation } from "../../reducer/quoteReducer";
import DialogComp from "../../components/Dialog-Popup";
import moment from "moment";
import "./styles.css";
import {
  getAppState,
  getNextJobState,
  getNextQuoteState,
  QuoteBTNs,
  JobBTNs,
  JobState,
} from "../../businesslogic";

export default function JobDetailsFun(props) {
  const navigate = useNavigate();
  const { stateValue } = props;
  const [showInspectedJob, setShowInspectedJob] = useState(false);
  const [showStartedJob, setSHowStartedJob] = useState(false);
  const [btmSht, setBtmSht] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [popuptitle, SetPopupTitle] = useState("");
  const [popupContent, SetPopupContent] = useState("");
  const [buttonArr, setButtonArr] = useState([]);
  const [jobDetailsData, setJobDetailsData] = useState(null);

  let quoteStatus = stateValue?.quotes?.[0]?.status;
  let jobStatus = stateValue?.status;
  let appState = getAppState(jobStatus, quoteStatus);

  let btnEvntHandlerMap = new Map();
  btnEvntHandlerMap.set(JobBTNs.Accept, acceptJob_EH);
  btnEvntHandlerMap.set(JobBTNs.Reject, rejectJob_EH);
  btnEvntHandlerMap.set(JobBTNs.Inspect, inspectJob_EH);
  btnEvntHandlerMap.set(JobBTNs.Start, startJob_EH);
  btnEvntHandlerMap.set(JobBTNs.Complete, completeJob_EH);

  useEffect(() => {
    setJobDetailsData(stateValue);
  }, [stateValue]);

  function acceptJob_EH(buttonName) {
    appState.action = buttonName;
    callApi(appState);
  }

  function rejectJob_EH(buttonName) {
    appState.action = buttonName;
    rejectJobFun();
  }

  function inspectJob_EH(buttonName) {
    appState.action = buttonName;
    JobInspectPopupFunc();
  }

  function startJob_EH(buttonName) {
    appState.action = buttonName;
    callApi(appState);
  }

  function completeJob_EH(buttonName) {
    appState.action = buttonName;
    JobCompletePopupFunc();
  }

  function callApi(appState) {
    const nextQuoteState = getNextQuoteState(appState);
    const nextJobState = getNextJobState(appState);

    if (nextJobState != null) {
      sendJobStatusAPI(nextJobState);
    }
    if (nextQuoteState != null) {
      sendQuoteStatusAPI(nextQuoteState);
    }
  }

  let firstName = jobDetailsData?.address?.firstname;
  let JobId = jobDetailsData?.id;

  function rejectJobFun() {
    setOpenPopup(true);
    SetPopupTitle("Are you sure?");
    SetPopupContent(
      "You are trying to reject the Job request from " +
        jobDetailsData?.address?.firstname +
        ", Please confirm if you are sure."
    );
    setButtonArr([ 
      { id: "1", value: "Confirm", functionCall: () => callApi(appState) },
      { id: "2", value: "Cancel", functionCall: closeFunc },
    ]);
  }

  function acceptJobFun() {
    setOpenPopup(true);
    SetPopupTitle("Thank You");
    SetPopupContent(
      `Thank you for accepting the requested service on ${DateConverter(
        jobDetailsData?.date
      )} at ${TimeConverter(jobDetailsData?.time)} to the given address`
    );
    setButtonArr([
      { id: "1", value: "Close", functionCall: redirectHomePage },
    ]);
  }

  function inspectJobFun() {
    setOpenPopup(true);
    SetPopupTitle("Thank You!");
    SetPopupContent("You have marked the Inspection at site successfully.");
    setButtonArr([ 
      { id: "1", value: "Ok", functionCall: closeInspectPopup },
    ]);
  }

  function closeInspectPopup() {
    setOpenPopup(false);
    setSHowStartedJob(true);
  }

  function confirmRejectFunc() {
    setOpenPopup(false);
    SetPopupTitle("Confirm Rejection");
    SetPopupContent(
      "You have rejected the selected Job request from Anna."
    );
    setButtonArr([ 
      { id: "1", value: "Ok", functionCall: redirectHomePage },
    ]);
    setOpenPopup(true);
  }

  function closeFunc() {
    setOpenPopup(false);
  }

  function redirectHomePage() {
    setOpenPopup(false);
    navigate("/plumber");
  }

  function DateConverter(data) {
    return moment(data).format("L");
  }

  function TimeConverter(data) {
    return moment(data).format("LT");
  }

  function redirectQuotesTab() {
    setOpenPopup(false);
    let stateObj = {
      tabVal: 1,
      jobStatus,
      quoteStatus,
      id: stateValue.id,
      editQuote: true,
    };
    // Updated to pass JobId when navigating
    navigate("/Job-quoteCal", { state: stateObj });
  }

  function JobInspectPopupFunc() {
    setOpenPopup(true);
    SetPopupTitle("Are you sure?");
    SetPopupContent(
      "Please continue if you have inspected the Job or Edit the Quote if you have anything to change in the existing calculation."
    );
    setButtonArr([
      { id: "1", value: "Edit", functionCall: redirectQuotesTab },
      { id: "1", value: "Continue", functionCall: () => callApi(appState) },
    ]);
  }

  function JobCompletePopupFunc() {
    setOpenPopup(true);
    SetPopupTitle("Are you sure?");
    SetPopupContent(
      "Please continue if you have completed the Job or Edit the Quote if you have anything to change in the existing calculation."
    );
    setButtonArr([
      { id: "1", value: "Edit", functionCall: redirectQuotesTab },
      { id: "1", value: "Continue", functionCall: () => callApi(appState) },
    ]);
  }

  function jobCompletedPopup() {
    setOpenPopup(true);
    SetPopupTitle("Thank You!");
    SetPopupContent(
      "Thank you for completing Job #1220. Please ensure job completion by uploading all the invoices and bills."
    );
    setButtonArr([ 
      { id: "1", value: "Continue", functionCall: uploadInvoicesFun },
    ]);
  }

  function uploadInvoicesFun() {
    setOpenPopup(false);
    navigate("/UploadInvoice");
  }

  const [sendJobStatus] = useUpdateJobStatusMutation();
  async function sendJobStatusAPI(str) {
    const paramsData = { status: str }; 
    try {
      let Id = JobId;
      const response = await sendJobStatus({ Id, paramsData });
      if (response.data) {
        handleJobStateChange(str, response.data.status);
      }
    } catch (err) {
      console.log(err);
    }
  }

  const [revisedSendQuoteAPI] = useSendRevisedQuoteDetailsMutation();
  async function sendQuoteStatusAPI(str) {
    const paramsData = { status: str }; 
    let method = "PATCH";
    let Id = Number(JobId);
    try {
      const response = await revisedSendQuoteAPI({ Id, method, paramsData });
      if (response.data) {
        // Handle quote status response
      }
    } catch (err) {
      console.log(err);
    }
  }

  function handleJobStateChange(str, jobState) {
    if (str === "JobAccepted") {
      acceptJobFun();
    } else if (str === "New") {
      confirmRejectFunc();
    } else if (str === "JobFinalised") {
      setOpenPopup(false);
      setShowInspectedJob(true);
    } else if (str === "JobStarted") {
      setSHowStartedJob(true);
      setTimeout(() => {
        // Job started logic here
      }, 3000);
    } else if (str === "JobCompleted") {
      jobCompletedPopup();
    }
  }

  function getButtonsFunc() {
    return (
      <Grid
        display="flex"
        justifyContent={appState?.jdButton1 && appState?.jdButton2 ? "space-between" : "center"}
        bgcolor="#ffffff"
        padding="12px 20px"
        width="100%"
        style={{ position: "sticky", bottom: "0", left: "0" }}
      >
        <div>
          {appState?.jdButton1 && (
            <Button
              value={appState.jdButton1}
              onClick={() => btnEvntHandlerMap.get(appState.jdButton1)()}
            />
          )}
        </div>
        <div>
          {appState?.jdButton2 && (
            <Button
              value={appState.jdButton2}
              onClick={() => btnEvntHandlerMap.get(appState.jdButton2)()}
            />
          )}
        </div>
      </Grid>
    );
  }

  return (
    <>
      <JobDetailComp JobDetailsData={jobDetailsData} />
     
      <BottomSheet
        open={openPopup}
        onDismiss={() => setOpenPopup(false)}
        snapPoints={({ maxHeight }) => [maxHeight / 1.3, maxHeight / 3]}
      >
        <div className="pop-up-cls">
          <Typography sx={{ fontSize: "22px", fontWeight: "600" }}>{popuptitle}</Typography>
          <Typography sx={{ fontSize: "20px", fontWeight: "500", mt: 3 }}>{popupContent}</Typography>
          {buttonArr?.map((item, i) => (
            <div
              key={i}
              className="btnDivCls"
              onClick={() => item.functionCall()}
            >
              <div>{item.value}</div>
            </div>
          ))}
        </div>
      </BottomSheet>
      {getButtonsFunc()}
    </>
  );
}
